import React from "react"
import { Link } from 'gatsby'

export default function NewsletterSummary({
    newslettersId,
    date,
    title,
    body
}) {
  return (
    <>
    <div className="newsletter_list" key={newslettersId}>
      <div className="newsletter_data">{date}</div>
      <div className="newsletter_title">{title}</div>
      <div dangerouslySetInnerHTML={{__html: body.replace(/\n/g, '<br />')}}/>
      <Link className="newsletter_more" to={'/newsletter/' + newslettersId}>続きを読む</Link>
    </div>
    </>
  )
}
